import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ExpirationLabel: React.FC<{ expirationDate: string }> = ({
  expirationDate,
}) => (
  <div
    style={{
      width: "50mm",
      height: "30mm",
      padding: "10mm",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      pageBreakAfter: "always",
      fontFamily: '"游ゴシック体", "Yu Gothic", "メイリオ", sans-serif',
      boxSizing: "border-box",
      border: "1px solid #ccc",
    }}
  >
    <div
      style={{
        fontSize: "11px",
        fontWeight: 800,
        textAlign: "center",
        lineHeight: "1.2",
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 3,
        WebkitBoxOrient: "vertical",
        wordBreak: "break-word",
        width: "100%",
        marginTop: "2.5px",
        fontFamily: '"Arial Black", "BIZ UD Gothic", "Meiryo", sans-serif',
      }}
    >
      賞味期限
    </div>
    <div
      style={{
        fontSize: "11px",
        fontWeight: 800,
        textAlign: "center",
        lineHeight: "1.2",
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 3,
        WebkitBoxOrient: "vertical",
        wordBreak: "break-word",
        width: "100%",
        marginTop: "2.5px",
        fontFamily: '"Arial Black", "BIZ UD Gothic", "Meiryo", sans-serif',
      }}
    >
      {expirationDate}
    </div>
  </div>
);

const PrintExpirationLabelsPage: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const key = params.get("key");
  const itemsRaw = key ? localStorage.getItem(key) : null;

  const items: { expirationDate: string; count: number }[] = itemsRaw
    ? JSON.parse(itemsRaw)
    : [];

  useEffect(() => {
    setTimeout(() => window.print(), 500);
    window.onafterprint = () => {
      if (window.opener) window.opener.focus();
      window.close();
    };
  }, []);

  return (
    <div>
      {items.flatMap(({ expirationDate, count }, i) =>
        Array.from({ length: count }).map((_, j) => (
          <ExpirationLabel key={`${i}-${j}`} expirationDate={expirationDate} />
        ))
      )}
      <style>{`
        @page {
          size: 80mm 50mm;
          margin: 0;
        }
        @media print {
          body {
            margin: 0;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }
      `}</style>
    </div>
  );
};

export default PrintExpirationLabelsPage;
